<template lang="pug">
.features.width-100.row(:class='{small}')
  .feature.row
    .icon(:class='small ? "m-right-05" : "m-right-1"')
      simple-svg.dark-gray-icon(
        :filepath='bookIcon'
        :width='small ? "15px" : "20px"'
        :height='small ? "15px" : "20px"'
      )
    .column
      span.feature-title.dark-gray.m-bottom-1 {{ navigation ? $t('listPrograms.resourcesLabel') : innerI18n.t('listPrograms.resourcesLabel') }}
      .feature-value(:class='{small}') {{ program.resources }}
  .feature.row
    .icon(:class='small ? "m-right-05" : "m-right-1"')
      simple-svg.dark-gray-icon(
        :filepath='calendarIcon'
        :width='small ? "15px" : "20px"'
        :height='small ? "15px" : "20px"'
      )
    .column
      span.feature-title.dark-gray.m-bottom-1 {{ navigation ? $t('listPrograms.durationLabel') : innerI18n.t('listPrograms.durationLabel') }}
      .feature-value(:class='{small}') {{ navigation ? $tc('listPrograms.lectures', program.duration ) : innerI18n.tc('listPrograms.lectures', program.duration ) }}
  .feature.row(v-if='!isTeachersTraining')
    .icon(:class='small ? "m-right-05" : "m-right-1"')
      simple-svg.dark-gray-icon(
        :filepath='userIcon'
        :width='small ? "15px" : "20px"'
        :height='small ? "15px" : "20px"'
      )
    .column
      span.feature-title.dark-gray.m-bottom-1 {{ navigation ? $t('listPrograms.ageRangeLabel') : innerI18n.t('listPrograms.ageRangeLabel') }}
      .feature-value
        p.row.middle.text-normal.age-desc(
          v-if='program.ageRange'
          :class='{small}'
          :style="getAgeRangeStyle(program.ageRange.mainColor)"
        )
          | {{ navigation ? $t('listPrograms.ageRange', program.ageRange) : innerI18n.t('listPrograms.ageRange', program.ageRange) }}
        p.row.middle.text-normal.age-desc(
          v-if='program.secondaryAgeRange'
          :class='{small}'
          :style='getAgeRangeStyle(program.secondaryAgeRange.mainColor)'
        )
          | {{ navigation ? $t('listPrograms.ageRange', program.secondaryAgeRange) : innerI18n.t('listPrograms.ageRange', program.secondaryAgeRange) }}
</template>

<script>
import bookIcon from '@/assets/ic_book.svg'
import userIcon from '@/assets/ic_user.svg'
import calendarIcon from '@/assets/ic_calendar.svg'
import { innerI18n } from '../../main'
import { teachersTrainingReferenceId } from '../../constants/resource'

export default {
  props: {
    program: { type: Object, required: true },
    navigation: { type: Boolean },
    small: { type: Boolean }
  },
  data() {
    return {
      bookIcon,
      userIcon,
      calendarIcon,
      innerI18n
    }
  },
  computed: {
    isTeachersTraining() {
      return this.program.categoryReferenceId === teachersTrainingReferenceId
    }
  },
  methods: {
    getAgeRangeStyle(color) {
      return {
        '--age-color': color
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

.features {
  gap: 75px;
  &.small{
    gap: 14px;
  }
}

.feature-title {
  color: $dark-gray;
}

.feature-value{
  &.small{
    font-size: 14px;
  }
}

.age-desc {
  position: relative;
  padding-left: 20px;
  margin-bottom: 5px;
  &.small{
    font-size: 14px;
    padding-left: 14px;
  }
  &::before {
    content: '';
    background-color: var(--age-color);
    border-radius: 100%;
    height: 8px;
    position: absolute;
    margin-right: 10px;
    width: 8px;
    left: 0px;
    &.small{
      margin-right: 4px;
    }
  }
}
</style>
